import React from "react";
import { Link } from "react-router-dom";
import { MessageCircleMore } from "lucide-react";
import Container from "../components/Container";
import Breadcrumb from "../components/Breadcrumb";
import { cls } from "../utils/helpers";
import { WHATSAPP_NUM } from "../utils/constants";

function openWhatsApp(preset) {
  const num = WHATSAPP_NUM.replace(/\D/g, "");
  const text = encodeURIComponent(
    preset ||
      "Bonjour, je souhaite échanger au sujet de vos prestations / software."
  );
  window.open(`https://wa.me/${num}?text=${text}`, "_blank");
}

function HtmlText({ html, className }) {
  return <p className={className} dangerouslySetInnerHTML={{ __html: html }} />;
}

export default function PrestationsPage({ p, t }) {
  const sections = [
    {
      id: "presta-direction",
      title: t("presta.direction"),
      bullets: [
        t("presta.direction.b1"),
        t("presta.direction.b2"),
        t("presta.direction.b3"),
      ],
    },
    {
      id: "presta-pilotage",
      title: t("presta.pilotage"),
      bullets: [
        t("presta.pilotage.b1"),
        t("presta.pilotage.b2"),
        t("presta.pilotage.b3"),
      ],
    },
    {
      id: "presta-etudes",
      title: t("presta.etudes"),
      bullets: [
        t("presta.etudes.b1"),
        t("presta.etudes.b2"),
        t("presta.etudes.b3"),
      ],
    },
    {
      id: "presta-suivi",
      title: t("presta.suivi"),
      bullets: [
        t("presta.suivi.b1"),
        t("presta.suivi.b2"),
        t("presta.suivi.b3"),
      ],
    },
    {
      id: "presta-optimisation",
      title: t("presta.optim"),
      bullets: [
        t("presta.optim.b1"),
        t("presta.optim.b2"),
        t("presta.optim.b3"),
      ],
    },
    {
      id: "presta-logistique",
      title: t("presta.log"),
      bullets: [
        t("presta.log.b1"),
        t("presta.log.b2"),
        t("presta.log.b3"),
      ],
      showPricing: false,
    },
  ];

  return (
    <>
      <Container>
        <Breadcrumb
          items={[{ label: t("crumb.home"), href: "/" }, { label: t("nav.prestations") }]}
          p={p}
        />
      </Container>

      <section className={p.hero}>
        <Container>
          <div className="py-12">
            <h1 className={cls("text-3xl font-extrabold", p.cardTitle)}>
              {t("presta.title")}
            </h1>
            <HtmlText
              html={t("presta.subtitle")}
              className={cls("mt-2 max-w-3xl", p.paragraph)}
            />
            <div className="mt-6 flex flex-wrap gap-2">
              <a href="#presta-direction" className={p.chip}>
                {t("chip.direction")}
              </a>
              <a href="#presta-pilotage" className={p.chip}>
                {t("chip.pilotage")}
              </a>
              <a href="#presta-etudes" className={p.chip}>
                {t("chip.etudes")}
              </a>
              <a href="#presta-suivi" className={p.chip}>
                {t("chip.suivi")}
              </a>
              <a href="#presta-optimisation" className={p.chip}>
                {t("chip.optimisation")}
              </a>
              <a href="#presta-logistique" className={p.chip}>
                {t("chip.logistique")}
              </a>
              <Link to="/contact" className={p.chipAlt || p.chip}>
                {t("chip.quote")}
              </Link>
            </div>
          </div>
        </Container>
      </section>

      {sections.map((s) => (
        <section key={s.id} id={s.id} className="scroll-mt-24 py-10">
          <Container>
            <div className={p.card}>
              <h2 className={cls("text-xl font-bold", p.cardTitle)}>{s.title}</h2>
              <ul className="mt-3 text-sm space-y-1">
                {s.bullets.map((b, i) => (
                  <li key={i} className="flex gap-2 items-start">
                    <span className="mt-[6px] h-1.5 w-1.5 rounded-full bg-current" />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-4 flex gap-2">
                {s.showPricing ? (
                  <Link to="/pricing" className={p.ctaPrimary}>
                    {t("nav.pricing")}
                  </Link>
                ) : (
                  <Link to="/contact" className={p.ctaPrimary}>
                    {t("nav.quote")}
                  </Link>
                )}
                <button
                  onClick={() =>
                    openWhatsApp(
                      "Bonjour, je souhaite un devis pour vos prestations."
                    )
                  }
                  className={cls(p.ctaSecondary, "inline-flex items-center gap-2")}
                >
                  <MessageCircleMore size={16} /> WhatsApp
                </button>
              </div>
            </div>
          </Container>
        </section>
      ))}
    </>
  );
}
